import { Environment } from './interface'

export const environment: Environment = {
  apiHost: 'https://devo.lainasto.fi',
  appHost: 'https://app-dev.gfcard.fi',
  companyAddress: 'Pitkämäenkatu 11',
  companyCity: 'Turku',
  companyId: '2382033-5',
  companyName: 'GF Money Oy',
  companyPostalCode: '20250',
  email: 'asiakaspalvelu@gfcard.fi',
  environment: 'dev',
  logApiUrl: 'https://mira.gfcard.fi/api',
  masterCardUrl: 'https://gf.pckt.cloud',
  phone: '09 427 05044',
  production: false,
  servicesApiHost: 'https://services.lainasto.fi',
  serviceId: 35,
}
